import type { Preview } from '@/api/types'
import { Badge } from '@/components/ui/Primitives'
import { ATS_LABEL, formatDate, formatDuration } from '@/lib/utils'

/** What a career page would give, read without saving ("Test URL"). */
export function PreviewPanel({ preview }: { preview: Preview }) {
  const withDescription = preview.jobs.filter((j) => j.has_description).length
  return (
    <div className="rounded-field border border-line bg-surface-muted/60">
      <div className="flex flex-wrap items-center gap-2 border-b border-line px-4 py-3 text-[13px]">
        <Badge tone={preview.jobs_found ? 'success' : 'warning'}>
          {preview.jobs_found ? `${preview.total_available ?? preview.jobs_found} jobs` : 'No jobs found'}
        </Badge>
        <Badge tone="info">{ATS_LABEL[preview.ats_type]}</Badge>
        {preview.company_name && <span className="font-medium">{preview.company_name}</span>}
        <span className="ml-auto text-ink-muted">{formatDuration(preview.duration_ms)}</span>
      </div>
      {preview.notes.length > 0 && (
        <ul className="border-b border-line px-4 py-2 text-[12.5px] text-ink-muted">
          {preview.notes.map((n) => (
            <li key={n}>• {n}</li>
          ))}
        </ul>
      )}
      {preview.jobs.length > 0 && (
        <>
          <p className="px-4 pt-2 text-[12px] text-ink-muted">
            First {preview.jobs.length} · {withDescription} with full description
          </p>
          <ul className="max-h-64 overflow-y-auto px-4 py-2">
            {preview.jobs.map((job) => (
              <li key={job.external_id} className="flex items-baseline justify-between gap-3 border-b border-line/70 py-1.5 text-[13px] last:border-0">
                <span className="min-w-0 truncate">
                  {job.job_url ? (
                    <a className="link" href={job.job_url} target="_blank" rel="noreferrer">
                      {job.title}
                    </a>
                  ) : (
                    job.title
                  )}
                  <span className="text-ink-muted"> · {job.location ?? 'Location n/a'}</span>
                </span>
                <span className="shrink-0 text-[12px] text-ink-faint">{job.posted_at ? formatDate(job.posted_at) : ''}</span>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  )
}
